import { CARD_TYPES } from '../../../shared/constants';

import colors from '../../../styles/colors';

export const getTextColor = (
  type: 'preview-card' | 'gated-download-card',
  isFullWidth: boolean
): string => {
  if (isFullWidth) {
    return colors.white;
  }

  return type === CARD_TYPES.previewCard ? colors.white : colors.abnNeutral670;
};
